<div class="office-search">
    <div class="container default-container">
        <div class="row">
            <div class="field field-classification col-auto row">
                <select-dropdown class="searchType" [options]="optionsTitle" [selected]="selectedSearchType"
                    (changeSelectedValue)="onChangeSearchType($event)">
                </select-dropdown>
            </div>
            <div class="field field-input col row">
                <input type="text" class="search-key col" id="searchValue" [(ngModel)]="searchKey"
                    (keydown.enter)="onSearch()">
            </div>
            <div class="field submit-wrapper col-auto row">
                <a class="w-btn prime-btn submit-btn" id="btnSearch" (click)="onSearch()">
                    <span>{{'common.009' | translate}}</span>
                    <i class="bi bi-search"></i>
                </a>
            </div>
        </div>
    </div>
</div>

<div class="container mobile-container office-result">
    <div class="mobile-block last none">
        <paging
        [len]="len"
        [page]="page"
        [config]="config"
        [totalItems]="totalItems"
        (changePage)="handleOnChangePage($event)"
        (totalPage)="onTotalPage($event)"
        (changeLen)="handleOnChangeSelectedValue($event)"
        [turnOnTotalPage]="true"
        [turnOnPagination]="false"
        [turnOnTotalItem]="true"
        [isMobile]="true"
    ></paging>
        <div class="table-wrapper draggable-wrapper" draggableWrapper>
            <table class="notices-table">
                <thead>
                    <tr>
                        <th style="width: 95px;">번호</th>
                        <th>제목</th>
                        <!-- <th>조회 수</th>
                        <th>등록일자</th> -->
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let item of collection | paginate: config; let i = index">
                        <tr (click)="handleOnClickBoardNo(item.boardNo)" style="cursor: pointer">
                            <td>
                                <div class="post-icon">
                                    <span>{{ i+1 }}</span>
                                </div>
                            </td>
                            <td>{{ item.title }}</td>
                            <!-- <td>{{ item.readCnt }}</td>
                            <td>{{ item.insDate }}</td> -->
                        </tr>
                    </ng-container>
                    <ng-container *ngIf="totalRows < 5">
                        <tr *ngFor="let row of rows; index as i">
                            <ng-container *ngFor="let col of cols; index as j">
                                <td>
                                    <span>&nbsp;</span>
                                    <ng-container *ngIf="totalRows === 0 && i === 2 && j === floorTotalCols">
                                        <span class='h-small empty-warning'>{{"no-data" | translate}}</span>
                                    </ng-container>
                                </td>
                            </ng-container>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
        <paging
        [len]="len"
        [page]="page"
        [config]="config"
        [totalItems]="totalItems"
        (changePage)="handleOnChangePage($event)"
        (totalPage)="onTotalPage($event)"
        (changeLen)="handleOnChangeSelectedValue($event)"
        [turnOnTotalPage]="true"
        [turnOnPagination]="true"
        [turnOnTotalItem]="true"
        [isMobile]="false"
    ></paging>
    </div>

</div>